module.exports = __webpack_public_path__ + "img/result of acoustical PD localaization at power transformer.fbe91177.jpg";